module.exports = __webpack_public_path__ + "img/list46.b01d221f.jpeg";